export default {
  labels: {
    dwellingBeds: { en: "Bedrooms" },
    dwellingCars: { en: "Parking" },
    dwellingSize: { en: "Build Up Area" },
  },

  general: {
    showSoldLabel: false,
  },

  filter: {
    enabled: false,
  },

  markerIcons: {
    house: ["far", "house"],
  },
};
